import _defineProperty from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useState, useRef, useEffect, useContext, useMemo, useImperativeHandle } from 'react';
import { MountedMapsContext } from './use-map';
import Mapbox from '../mapbox/mapbox';
import createRef from '../mapbox/create-ref';
import useIsomorphicLayoutEffect from '../utils/use-isomorphic-layout-effect';
import setGlobals from '../utils/set-globals';
export var MapContext = React.createContext(null);
export default function Map(props, ref, defaultLib) {
  var mountedMapsContext = useContext(MountedMapsContext);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    mapInstance = _useState2[0],
    setMapInstance = _useState2[1];
  var containerRef = useRef();
  var _useRef = useRef({
      mapLib: null,
      map: null
    }),
    contextValue = _useRef.current;
  useEffect(function () {
    var mapLib = props.mapLib;
    var isMounted = true;
    var mapbox;
    Promise.resolve(mapLib || defaultLib).then(function (module) {
      if (!isMounted) {
        return;
      }
      if (!module) {
        throw new Error('Invalid mapLib');
      }
      var mapboxgl = 'Map' in module ? module : module.default;
      if (!mapboxgl.Map) {
        throw new Error('Invalid mapLib');
      }
      // workerUrl & workerClass may change the result of supported()
      // https://github.com/visgl/react-map-gl/discussions/2027
      setGlobals(mapboxgl, props);
      if (!mapboxgl.supported || mapboxgl.supported(props)) {
        if (props.reuseMaps) {
          mapbox = Mapbox.reuse(props, containerRef.current);
        }
        if (!mapbox) {
          mapbox = new Mapbox(mapboxgl.Map, props, containerRef.current);
        }
        contextValue.map = createRef(mapbox);
        contextValue.mapLib = mapboxgl;
        setMapInstance(mapbox);
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapMount(contextValue.map, props.id);
      } else {
        throw new Error('Map is not supported by this browser');
      }
    }).catch(function (error) {
      var onError = props.onError;
      if (onError) {
        onError({
          type: 'error',
          target: null,
          originalEvent: null,
          error: error
        });
      } else {
        console.error(error); // eslint-disable-line
      }
    });
    return function () {
      isMounted = false;
      if (mapbox) {
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapUnmount(props.id);
        if (props.reuseMaps) {
          mapbox.recycle();
        } else {
          mapbox.destroy();
        }
      }
    };
  }, []);
  useIsomorphicLayoutEffect(function () {
    if (mapInstance) {
      mapInstance.setProps(props);
    }
  });
  useImperativeHandle(ref, function () {
    return contextValue.map;
  }, [mapInstance]);
  var style = useMemo(function () {
    return _objectSpread({
      position: 'relative',
      width: '100%',
      height: '100%'
    }, props.style);
  }, [props.style]);
  var CHILD_CONTAINER_STYLE = {
    height: '100%'
  };
  return React.createElement("div", {
    id: props.id,
    ref: containerRef,
    style: style
  }, mapInstance && React.createElement(MapContext.Provider, {
    value: contextValue
  }, React.createElement("div", {
    "mapboxgl-children": "",
    style: CHILD_CONTAINER_STYLE
  }, props.children)));
}